import { render, staticRenderFns } from "./TheAutoRankingPreferenceTd.vue?vue&type=template&id=6a9edf1e&scoped=true&lang=pug&"
import script from "./TheAutoRankingPreferenceTd.vue?vue&type=script&lang=js&"
export * from "./TheAutoRankingPreferenceTd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9edf1e",
  null
  
)

export default component.exports